export const casestudiesPosts = [
  {
    id: 1,
    image: "/Casestudy Images/caseStudyImg1.png",
    title: "Transforming Email Management with AI",
    date: "Aug 14,2025",
  },
  {
    id: 2,
    image: "/Casestudy Images/caseStudyImg2.png",
    title: "Empowering E-Commerce with Visual Search",
    date: "Jun 10,2025",
  },
  {
    id: 3,
    image: "/Casestudy Images/caseStudyImg3.png",
    title: "Revolutionizing Insurance Support with AI Agent",
    date: "May 20,2025",
  },
  {
    id: 4,
    image: "/Casestudy Images/caseStudyImg4.jpg",
    title: "Broker Underwriting Interaction Automation with Agentic AI",
    date: "May 20,2025",
  },
  {
    id: 5,
    image: "/Casestudy Images/caseStudyImg5.jpg",
    title: "Agentic AI – Intelligent Reporting Agents",
    date: "May 20,2025",
  },
  {
    id: 6,
    image: "/Casestudy Images/caseStudyImg6.jpg",
    title: "Agentic AI – Customer Experience",
    date: "May 20,2025",
  },
];

export const casestudiesContent = [
  {
    id: 1,
    title: "Transforming Email Management with AI",
    industry: "Communication ",
    image: "/Casestudy Images/caseStudyImg1.png",
    overview: {
      heading: "Overview",
      content:
        "Managing thousands of daily emails manually led to delays, miscommunication, and compliance risks. Canvendor deployed an AI-powered system to automate, track, and optimize email workflows, enabling smarter communication across departments.",

      list: [],
    },
    businessChallenges: {
      heading: "Business Challenges",
      content: "",
      list: [
        "Overwhelming email volume causing processing delays",
        "Emails misrouted due to manual categorization",
        "Inconsistent customer response times",
        "Difficulty ensuring compliance and audit readiness",
      ],
    },
    keyCapabilities: {
      heading: "Key Capabilities",
      content: "",
      list: [
        "Auto-Categorization – Intelligent sorting based on content and urgency",
        "Tone & Intent Detection – Understands message type (complaint, query, etc.)",
        "Suggested Replies – Auto-generated responses to reduce effort",
        "Performance Dashboards – Real-time visibility into email flow and team performance",
      ],
    },
    aboutCanvendor: {
      heading: "About Canvendor",
      content:
        "Canvendor delivers AI-driven solutions that simplify complex workflows. From intelligent search to automated communication, we help businesses scale faster, serve smarter, and stay ahead.",
      list: [],
    },
    businessImpact: {
      heading: "Business Impact",
      content: "",
      list: [
        "40% faster email responses",
        "30% fewer misclassifications",
        "Smarter workflows and reduced manual effort",
        "Better compliance tracking",
        "Real-time operational insights",
      ],
    },
  },

  {
    id: 2,
    title: "Empowering E-Commerce with Visual Search",
    industry: "E-Commerce",
    image: "/Casestudy Images/caseStudyImg2.png",
    overview: {
      heading: "Overview",
      content:
        "Traditional keyword search couldn’t keep up with diverse customer input. Canvendor introduced a visual-first search experience, allowing customers to shop by image and discover relevant products more easily, regardless of language or terminology.",

      list: [],
    },
    businessChallenges: {
      heading: "Business Challenges",
      content: "",
      list: [
        "Keyword searches failed due to regional variations",
        "Poor product discovery lowered conversions",
        "Frustrating search experience for non-English users",
        "High cart abandonment and drop-off rates",
      ],
    },
    keyCapabilities: {
      heading: "Key Capabilities",
      content: "",
      list: [
        "Visual Search Interface – Enables image-based product discovery",
        "Product Matching Engine – Finds visually similar catalog items",
        "Language-Free Search – Works across languages and dialects",
        "Personalized Visual Recommendations – Suggests based on preferences and behavior",
      ],
    },
    aboutCanvendor: {
      heading: "About Canvendor",
      content:
        "Canvendor delivers AI-driven solutions that simplify complex workflows. From intelligent search to automated communication, we help businesses scale faster, serve smarter, and stay ahead.",
      list: [],
    },
    businessImpact: {
      heading: "Business Impact",
      content: "",
      list: [
        "Improved user satisfaction across all regions",
        "Increased conversion rates",
        "Reduced search drop-offs",
        "Enhanced product visibility",
        "Inclusive shopping experience for diverse audiences",
      ],
    },
  },

  {
    id: 3,
    title: "Revolutionizing Insurance Support with AI Agent",
    industry: "Insurance",
    image: "/Casestudy Images/caseStudyImg3.png",
    overview: {
      heading: "Overview",
      content:
        "Insurance support teams struggled with fragmented data, long response times, and growing compliance demands. Canvendor’s AI-powered virtual agent automated responses and integrated real-time data access for secure, efficient support.",

      list: [],
    },
    businessChallenges: {
      heading: "Business Challenges",
      content: "",
      list: [
        "Data scattered across multiple systems",
        "Long wait times for customers needing assistance",
        "Repetitive manual tasks draining support resources",
        "High risk of compliance breaches and audit issues",
      ],
    },
    keyCapabilities: {
      heading: "Key Capabilities",
      content: "",
      list: [
        "Conversational UI – Natural, human-like chatbot interface",
        "Multi-Source Integration – Pulls data from various systems instantly",
        "Secure Authentication – Protects sensitive info with OTP & ID validation",
        "Continuous Learning – Improves with every customer interaction",
      ],
    },
    aboutCanvendor: {
      heading: "About Canvendor",
      content:
        "Canvendor delivers AI-driven solutions that simplify complex workflows. From intelligent search to automated communication, we help businesses scale faster, serve smarter, and stay ahead.",
      list: [],
    },
    businessImpact: {
      heading: "Business Impact",
      content: "",
      list: [
        "50% reduction in manual workload",
        "80% faster customer response time",
        "24/7 automated support availability",
        "Audit-ready compliance reporting",
        "Increased customer trust and satisfaction",
      ],
    },
  },
  {
    id: 4,
    title: "Broker Underwriting Interaction Automation with Agentic AI",
    industry: "Insurance / Financial Services",
    image: "/Casestudy Images/caseStudyImg4.jpg",
    overview: {
      heading: "Overview",
      content:
        "Broker–underwriter communication was slowed by repetitive queries and manual checks. Canvendor used historical chat data to train an Agentic AI system that automates routine queries, executes transactions in core systems, and applies underwriting rules consistently — boosting speed and accuracy.",

      list: [],
    },
    businessChallenges: {
      heading: "Business Challenges",
      content: "",
      list: [
        "High volume of repetitive queries",
        "Inconsistent application of rules",
        "Delayed approvals/declines",
        "Experts tied up with low-value tasks",
        "Limited accuracy and transparency",
      ],
    },
    keyCapabilities: {
      heading: "Key Capabilities",
      content: "",
      list: [
        "AI Training from past interactions",
        "Automated Rule Application",
        "Instant Query Responses",
        "Decision Automation",
        "Accurate, Real-Time Reporting",
      ],
    },
    aboutCanvendor: {
      heading: "About Canvendor",
      content:
        "Canvendor delivers AI-driven solutions that simplify complex workflows. From intelligent search to automated communication, we help businesses scale faster, serve smarter, and stay ahead.",
      list: [],
    },
    businessImpact: {
      heading: "Business Impact",
      content: "",
      list: [
        "Faster processing of underwriting requests",
        "Experts freed for complex cases",
        "Improved decision accuracy & consistency",
        "Transparent, real-time reporting",
        "Higher broker satisfaction",
      ],
    },
  },
  {
    id: 5,
    title: "Agentic AI – Intelligent Reporting Agents",
    industry: "Insurance / Financial Services",
    image: "/Casestudy Images/caseStudyImg5.jpg",
    overview: {
      heading: "Overview",
      content:
        "Manual creation of reports and presentations was time-consuming, error-prone, and often lacked deeper insights. Canvendor implemented Agentic AI-powered Intelligent Reporting Agents to automate report generation, fill gaps in data, validate findings with high accuracy, and provide actionable insights — empowering teams to focus on strategic analysis rather than repetitive formatting work.",

      list: [],
    },
    businessChallenges: {
      heading: "Business Challenges",
      content: "",
      list: [
        "Long turnaround time for creating reports and presentations",
        "Inconsistent output quality and format",
        "Missing or incomplete data affecting accuracy",
        "Limited bandwidth for deep insights due to manual effort",
      ],
    },
    keyCapabilities: {
      heading: "Key Capabilities",
      content: "",
      list: [
        "Automated Report & Presentation Generation – With or without templates",
        "Data Analysis & Gap Filling – Descriptive statistics and missing data completion",
        "Insight Generation & Validation – Uses reasoning to challenge or confirm findings",
        "Template Preservation & Commentary – Maintains design while adding context",
        "High-Accuracy Outputs – Validated to ensure 99% correctness",
      ],
    },
    aboutCanvendor: {
      heading: "About Canvendor",
      content:
        "Canvendor delivers AI-driven solutions that simplify complex workflows. From intelligent search to automated communication, we help businesses scale faster, serve smarter, and stay ahead.",
      list: [],
    },
    businessImpact: {
      heading: "Business Impact",
      content: "",
      list: [
        "Significant time savings in report and presentation creation",
        "Improved accuracy & consistency of outputs",
        "Actionable, data-driven insights beyond initial requirements",
        "Higher efficiency — frees experts for strategic, high-value tasks",
      ],
    },
  },
  {
    id: 6,
    title: "Agentic AI – Customer Experience",
    industry: "Multi-Industry/Customer Service",
    image: "/Casestudy Images/caseStudyImg6.jpg",

    overview: {
      heading: "Overview",
      content:
        "Managing customer interactions across multiple channels often leads to delays, inconsistent experiences, and higher operational costs. Canvendor implemented an Agentic AI-powered Customer Experience platform that unifies chat, email, IVR, and social media support into a single intelligent system. It detects customer intent in real time, processes queries with or without attachments, and triggers workflows instantly — ensuring fast, consistent, and personalised service.",

      list: [],
    },
    businessChallenges: {
      heading: "Business Challenges",
      content: "",
      list: [
        "Disconnected customer service channels causing inconsistent responses",
        "Manual query handling leading to longer resolution times",
        "Limited ability to operate 24/7 without increasing staffing costs",
        "High operational expenses from repetitive, routine interactions",
      ],
    },
    keyCapabilities: {
      heading: "Key Capabilities",
      content: "",
      list: [
        "Unified Conversation Understanding – Detects intent from chat, email, or voice",
        "Attachment Scanning – Extracts key details from documents like claims or receipts",
        "Smart Response Generation – Delivers accurate, context-based answers instantly",
        "Workflow Automation – Triggers actions like claim approvals or ticket status updates",
        "ulti-Channel Support – Operates seamlessly across chatbots, virtual agents, email, IVR, and social platforms",
      ],
    },
    aboutCanvendor: {
      heading: "About Canvendor",
      content:
        "Canvendor delivers AI-driven solutions that simplify complex workflows. From intelligent search to automated communication, we help businesses scale faster, serve smarter, and stay ahead.",
      list: [],
    },
    businessImpact: {
      heading: "Business Impact",
      content: "",
      list: [
        "24/7 intelligent customer support",
        "Faster case resolutions with minimal manual intervention",
        "Lower operational costs through automation of repetitive tasks",
        "Consistent, personalised customer experience across all touchpoints",
      ],
    },
  },
];
